"use client";

import { createContext } from "react";

export interface IOnboardingPermissionsContext {
  canEnterCustomerPortal: boolean;
  canEnterInternalPortal: boolean;

  // Computed view permission:booleans
  canEnterPortal: boolean;
  // Base requirement:booleans
  hasAcceptedPrivacyPolicy: boolean;

  hasAcceptedTermsOfService: boolean;
  hasPassedVerification: boolean;
  hasEnteredFirstName: boolean;
  hasEnteredFullName: boolean;
  hasEnteredLastName: boolean;
  isMintRedeemerApproved: boolean;

  // Organization-level capabilities
  isMintRedeemerEligible: boolean;
  isVendorApproved: boolean;
  isVendorEligible: boolean;

  needsOnboarding: boolean;
  onboardingRequirements: {
    hasAcceptedPrivacyPolicy: boolean;
    hasAcceptedTermsOfService: boolean;
    hasPassedVerification: boolean;
    hasEnteredFullName: boolean;
  };
}

export const OnboardingPermissionsContext = createContext<IOnboardingPermissionsContext | null>(null);
